import { MyAxios, handleResponse, handleError } from '@services/SettingAxios';

class ServiceWishlist {
  async addWishlist(id, part, regionId): Promise<any> {
    return MyAxios.put<any>(`/api/wishlist/add?productId=${id}&part=${part}&regionId=${regionId}`).then(handleResponse).catch(handleError);
  }

  async deleteWishlist(id, regionId): Promise<any> {
    return MyAxios.delete<any>(`/api/wishlist/remove?productId=${id}&regionId=${regionId}`).then(handleResponse).catch(handleError);
  }
}

const serviceWishlistInstance = new ServiceWishlist();

export default serviceWishlistInstance;
